import React from "react";
import Pagination from "@mui/material/Pagination";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import {Box, FormControl} from "@mui/material";
import CommonColorUtils from "../../utils/common_colors";

const MyPagination = ({
                          currentPage,
                          totalPages,
                          onPageChange,
                          rowsPerPage,
                          onRowsPerPageChange,
                          totalEntries,
                          setIsStart,
                          marginRight = "100px",
                          marginTop = "-20px",
                      }) => {
    const handlePageChange = (event, page) => {
        onPageChange(page - 1);
        setIsStart(true);
    };

    const handleRowsPerPageChange = (event) => {
        onRowsPerPageChange(event.target.value);
        onPageChange(0);
        setIsStart(true);
    };

    const startIndex = totalEntries > 0 ? (currentPage - 1) * rowsPerPage + 1 : 0;
    const endIndex = Math.min(currentPage * rowsPerPage, totalEntries);

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginTop: marginTop,
            }}
        >
            <div
                style={{marginLeft: "250px", display: "flex", alignItems: "center"}}
            >
                <div
                    style={{
                        marginLeft: "-250px",
                        marginRight: "10px",
                        fontFamily: "Inter, Arial, sans-serif",
                        color: "#6F727A",
                    }}
                >
                    Showing {startIndex}-{endIndex} of {totalEntries} entries
                </div>
                <FormControl
                    style={{
                        minWidth: 80,
                        marginRight: "10px",
                        fontFamily: "Inter, Arial, sans-serif",
                        color: "#6F727A",
                    }}
                >
                    <Select
                        labelId="rows-per-page-label"
                        id="rows-per-page-select"
                        value={rowsPerPage}
                        onChange={handleRowsPerPageChange}
                    >
                        {[20, 50, 100, 500].map((rows) => (
                            <MenuItem
                                key={rows}
                                value={rows}
                                sx={{
                                    fontFamily: "Inter, Arial, sans-serif",
                                    color: "#6F727A",
                                    fontWeight: "bold",
                                }}
                            >
                                {rows}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <div
                    style={{
                        marginTop: "5px",
                        fontFamily: "Inter, Arial, sans-serif",
                        color: "#6F727A",
                    }}
                >
                    rows per page
                </div>
            </div>
            <div
                style={{
                    marginRight: marginRight,
                    fontFamily: "Inter, Arial, sans-serif",
                    color: "#6F727A",
                }}
            >
                <Box
                    style={{
                        borderRadius: "8px",
                        backgroundColor: "white", // Set a background color for the container
                        border: "1px solid #E0E2E6", // Optional: Add a border
                        padding: "10px", // Add padding around the pagination
                        display: "flex", // Center the pagination horizontally
                        justifyContent: "center",
                    }}
                >
                    <Pagination
                        count={totalPages}
                        page={currentPage}
                        onChange={handlePageChange}
                        showFirstButton
                        showLastButton
                        sx={{
                            "& .MuiPaginationItem-root.Mui-selected": {
                                backgroundColor: CommonColorUtils.primaryMainBlue, // Use your primaryMainBlue color
                                color: "white", // Text color for the selected page
                            },
                        }}
                    />
                </Box>
            </div>
        </div>
    );
};

export default MyPagination;
